import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLinkedin} from "@fortawesome/free-brands-svg-icons";
import {FormattedMessage, injectIntl} from "react-intl";
import { LinkedIn } from 'react-linkedin-login-oauth2';
import {toast} from "react-toastify";
import Dropzone from '../../Dropzone/Dropzone'
import { handlePublicRequestError, Request } from '../../../helpers/request'


class FormJobPageButtons extends Component
{
    state = {
        file: null,
        code: null,
        linkedin_done: false
    };

    types = [
        'image/jpg',
        'image/jpeg'
    ];

    dropFile = (file) => {
       this.setState({file}, () => {
            this.props.onDrop(this.state.file);
        });
    };


    onDelete = () => {
        this.setState({file: null})
    }


    render() {

        return (
            <div className="upload-block">
                <Dropzone onDrop={file => this.dropFile(file)}
                          file={this.state.file}
                          allowPdf={true}
                          onDelete={this.onDelete}
                          placeholder={(<FormattedMessage
                              id="portfolio.form_job.buttons.resume"
                              defaultMessage="Votre CV ici"
                          />)}
                />
            </div>
        )
    }
}

export default injectIntl(FormJobPageButtons);
